import SectionHeading from '@/components/feature/SectionHeading';
import { themes } from '@/mocks/drama';

export default function Themes() {
  return (
    <section id="themes" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Core themes"
          title="核心主题解读"
          desc="这个题材之所以让人反复讨论，是因为它真正想讲的，并不是某一段关系本身。"
          align="center"
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {themes.map((theme, index) => (
            <div
              key={theme.title}
              className={`rounded-lg border p-5 md:p-6 ${
                index % 2 === 0
                  ? 'border-background-200 bg-background-50'
                  : 'border-secondary-200 bg-secondary-50'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${theme.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {theme.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{theme.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center gap-4 rounded-lg border border-primary-200 bg-primary-50 px-6 py-8 text-center md:flex-row md:justify-between md:text-left">
          <div>
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
              按主题继续挑选类似作品
            </h3>
            <p className="mt-1 text-sm text-foreground-600">
              如果你对「边界」「秘密」或「救赎」这类主题更感兴趣，可以回到推荐区按标签筛选。
            </p>
          </div>
          <a
            href="#recommend"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            前往作品推荐
          </a>
        </div>
      </div>
    </section>
  );
}